module.exports = __webpack_public_path__ + "img/dep_produce@2x.0ace6062.png";